import { Injectable } from '@angular/core';
import { Delivery, DeliveryList, WebserviceResponse} from "../interfaces";
import { HttpClient, HttpErrorResponse, HttpParams } from "@angular/common/http";
import { AlertService, IAlertType } from "./alert.service";
import { Observable, throwError } from "rxjs";
import { catchError, retry } from "rxjs/operators";
import { restBaseUrl } from "../utils/rest-url";

@Injectable({
  providedIn: 'root'
})
export class TransportStoreService {
  delivery: Delivery | null = null;

  private readonly endpoint = restBaseUrl('/transport');

  constructor(
      private http: HttpClient,
      private alertDispatcher: AlertService
  ) { }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Client-side error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Server-side error code: ${error.status} - message: ${error.message}`;
    }
    // window.alert(errorMessage);

    this.alertDispatcher.show({
      message: errorMessage,
      clrAlertType: IAlertType.DANGER
    }, 5000);

    // return throwError(errorMessage); deprecated
    return throwError(() => new Error(errorMessage));
  }

  // Main CRUD Services

  public getTransport(projectnumber:string, orderid: number, transportid: number, state:string): Observable<WebserviceResponse<Delivery[]>> {
    const options = new HttpParams({
      fromObject: {
        project_id: projectnumber,
        transport_id: transportid,
        order_id: orderid,
        status: state
      }
    });
    return this.http.get<WebserviceResponse<Delivery[]>>(this.endpoint + '/get_transport',
        { params: options }).pipe(
        retry(3),
        catchError(this.handleError.bind(this))
    );
  }

  public updateTransport(trans: Delivery) {
    return this.http.put(
        `${this.endpoint}/update_transport`,
        trans,
        { responseType: 'json'}
    ).pipe(
        retry(3),
        catchError(this.handleError.bind(this))
    );
  }

  public createTransportNote(prid: string, orderid: number, warehouseIds?: number[], jobid?: number) {
    const jobParam = jobid ? `&job_id=${jobid}` : '';
    const url = `${this.endpoint}/add_transport?order_id=${orderid}&project_id=${prid}${jobParam}`;
    const body = warehouseIds && warehouseIds.length > 0 ? { warehouse_ids: warehouseIds } : null;
    return this.http.post<WebserviceResponse<boolean>>(url, body).pipe(
      retry(3),
      catchError(this.handleError.bind(this))
    );
  }


  public deleteTransportNote(projectnumber: string, transportid: number ){
    return this.http.delete(
        `${this.endpoint}/delete_transport?transport_id=${transportid}&project_id=${projectnumber}`,
        { responseType: 'text'}
    ).pipe(
        retry(3),
        catchError(this.handleError.bind(this))
    );
  }

  // Transport Note Position Services

  public getTransportPositions(projectnumber: string, transportID: number, positionID: number, partID: number): Observable<WebserviceResponse<Delivery[]>> {
    const options = new HttpParams({
      fromObject: {
        project_id: projectnumber,
        transport_id: transportID,
        position: positionID,
        part: partID
      }
    });
    return this.http.get<WebserviceResponse<Delivery[]>>(this.endpoint + '/get_transport_position',
        { params: options }).pipe(
        retry(3),
        catchError(this.handleError.bind(this))
    );
  }

  public updateTransportPosition(trans: DeliveryList) {
    return this.http.put(
        `${this.endpoint}/update_transport_position`,
        trans,
        { responseType: 'json'}
    ).pipe(
        retry(3),
        catchError(this.handleError.bind(this))
    );
  }

  public deleteTransportPosition(projectnumber: string, transportID: number, positionID: string, partID: number) {
    return this.http.delete(
        `${this.endpoint}/delete_transport_position?project_id=${projectnumber}&transport_id=${transportID}&position=${positionID}&part=${partID}`,
        { responseType: 'text'}
    ).pipe(
        retry(3),
        catchError(this.handleError.bind(this))
    );
  }


  // Transport Status
  public updateTransportStatus(projectID: string, transportID: number, status: string){
    return this.http.put(
        `${this.endpoint}/update_status?project_id=${projectID}&transport_id=${transportID}&status=${status}`,
        { responseType: 'text'}
    ).pipe(
        retry(3),
        catchError(this.handleError.bind(this))
    );
  }
}
